import {JetView} from "webix-jet"; // Importing JetView from webix-jet for creating views
import FilterGetReportStructureGamesReports from "views/regulations/getReportStructureGames/filterGetReportStructureGames"; // Importing filter component for report structure
import TableGetReportStructureGamesReport from "views/regulations/getReportStructureGames/tableGetReportStructureGames"; // Importing table component for report structure

/**
 * Class representing the view for getting report structure for games.
 * @extends JetView
 */
export default class GetReportStructureGamesView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service for translations
        const theme = this.app.config.theme; // Theme configuration
        let vthis = this; // Reference to the current instance
        const toolbar = {
            id: "toolbar", // ID for the toolbar
            view: "toolbar", // Type of the UI component
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [ // Columns in the toolbar
                {
                    view:"select", // Dropdown for selecting page size
                    options:["10", "20", "50", "100"], // Options for page size
                    width: 70, // Width of the dropdown
                    on:{ // Event handlers
                        onChange: function(){
                            $$("datatable").getPager().config.size = this.getValue()*1; // Update pager size
                            $$("datatable").refresh(); // Refresh the datatable
                            $$('datatable').scrollTo(100,0); // Scroll to the top of the datatable
                            vthis.app.callEvent("changeSize", [{}]); // Trigger change size event
                        }
                    }
                },
                {
                    id: "pagerA", // ID for the pager
                    view: "pager", // Type of the UI component
                    template: "{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}", // Template for pager display
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                },
                {
                    id: "Export", // ID for the export dropdown
                    view: "richselect", // Type of the UI component
                    name: "Export", // Name of the component
                    width: 120, // Width of the dropdown
                    placeholder: _("Exportar"), // Placeholder text
                    options: [ // Options for export format
                        {id: "1", value: "Excel"}, // Option for Excel export
                        {id: "2", value: "PDF"} // Option for PDF export
                    ],
                    on: { // Event handlers
                        "onChange": function (value) {
                            if (value == 1) { // If Excel is selected
                                let table = $$("datatable"); // Get the datatable
                                for (let j = 0; j < table.config.columns.length; j++) { // Iterate through columns
                                    if (table.config.columns[j].exportType) { // Check if column is exportable
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent("export:data", [ // Trigger export data event
                                    {
                                        NameReport: ($$("datatable").count() > 0 ? "" : _("No hay datos - ")) + _("Estructura del Reporte para Juegos"), // Report name
                                        TypeReport: "Excel" // Report type
                                    }
                                ]);
                                webix.toExcel(table, { // Export to Excel
                                    filename: "Virtualsoft - " + new Date().toLocaleString("en-GB", {hour12: true}).replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1').replace(/[\/:]/g, '_').toUpperCase() + " - " + ($$("datatable").count() > 0 ? "" : _("No hay datos - ")) + _("Estructura del Reporte para Juegos") // Filename for the exported file
                                });
                            } else {
                                if (value == 2) { // If PDF is selected
                                    this.app.callEvent("export:data", [ // Trigger export data event
                                        {
                                            NameReport: ($$("datatable").count() > 0 ? "" : _("No hay datos - ")) + _("Estructura del Reporte para Juegos"), // Report name
                                            TypeReport: "PDF" // Report type
                                        }
                                    ]);
                                    webix.toPDF($$("datatable"), { // Export to PDF
                                        filename: "Virtualsoft - " + new Date().toLocaleString("en-GB", {hour12: true}).replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1').replace(/[\/:]/g, '_').toUpperCase() + " - " + ($$("datatable").count() > 0 ? "" : _("No hay datos - ")) + _("Estructura del Reporte para Juegos"), // Filename for the exported file
                                        autowidth: true // Enable auto width for PDF
                                    });
                                }
                            }
                            $$("Export").setValue(""); // Reset export selection
                        }.bind(this) // Bind the context to the event handler
                    }
                }
            ]
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: "a5", // ID for the main view
            type: "clean", // Type of the view
            view: "form", // Type of the UI component
            scroll: "y", // Enable vertical scrolling
            rows: [ // Rows in the form
                {
                    responsive: "a5", // Responsive design identifier
                    type: "wide", // Type of the row
                    cols: [ // Columns in the row
                        {
                            css: "int-left", // CSS class for styling
                            rows: [ // Rows in the column
                                {
                                    view: "toolbar", // Toolbar for the header
                                    css: theme, // Apply theme CSS
                                    elements: [ // Elements in the toolbar
                                        {
                                            view: "label", // Label for the report title
                                            label: _("Estructura del Reporte para Juegos") // Title text
                                        },
                                        {
                                            id: "button-search", // ID for the search button
                                            type: "wide", // Type of the button
                                            css: "close-bottom", // CSS class for styling
                                            cols: [ // Columns in the button
                                                {
                                                    view: "icon", // Icon for the search button
                                                    icon: "wxi-search", // Icon type
                                                    bottom: 20, // Bottom margin
                                                    right: 35, // Right margin
                                                    width: 30, // Width of the icon
                                                    height: 30, // Height of the icon
                                                    click: () => { // Click event handler
                                                        $$("filterPopup").show(); // Show filter popup
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            type: "wide", // Type of the button
                                            css: "close-bottom", // CSS class for styling
                                            cols: [ // Columns in the button
                                                {
                                                    view: "icon", // Icon for the close button
                                                    icon: "wxi-close", // Icon type
                                                    bottom: 20, // Bottom margin
                                                    right: 35, // Right margin
                                                    width: 30, // Width of the icon
                                                    height: 30, // Height of the icon
                                                    click: () => this.show("/top/dashboard") // Click event to navigate to dashboard
                                                }
                                            ]
                                        },
                                    ]
                                },
                                FilterGetReportStructureGamesReports, // Include filter component
                                TableGetReportStructureGamesReport, // Include table component
                                toolbar // Include toolbar
                            ]
                        }
                    ]
                }
            ]
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () { // Wait for Webix to be ready
            if (screen.width < 500 || screen.height < 500) { // Check for small screen size
                $$("toolbar").hide(); // Hide toolbar on small screens
            }
            if (screen.width > 500 && screen.height > 500) { // Check for larger screen size
                $$("button-search").hide(); // Hide search button on larger screens
            }
        });
    }
}

// FILE DOCUMENTED
